import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '../tooltip/tooltip.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditTransactionDateComponent } from './edit-transaction-date.component';
import { FormattedDateModule } from "../../pipes/formatted-date/formatted-date.module";
import { OwlDatepickerCustomizer } from '../../services/owl-datepicker-customizer.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';



@NgModule({
    declarations: [EditTransactionDateComponent],
    exports: [EditTransactionDateComponent],
    imports: [
        CommonModule,
        TooltipModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        FormattedDateModule
    ],
    providers: [OwlDatepickerCustomizer]
})
export class EditTransactionDateModule { }
